import { styled } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { Box, Button, Form, Stack, Text, TextInput } from 'shell/components';

const FinishedSignupPage = ({
    device,
    email,
    code,
    error,
    loading,
    handleChange,
    handleConfirmationCode,
    handleResendCode,
}) => {
    const { t } = useTranslation('auth');

    return (
        <VerifyEmailBox device={device}>
            <Stack alignItems={'center'}>
                <Text component={'h1'} variant={'h6'} weight={'medium'}>
                    {t('sign-up.email-sent', 'Email sent!')}
                </Text>
            </Stack>
            <Stack alignItems={'center'} sx={{ marginTop: '28px' }}>
                <Text variant={'p1'} sx={{ textAlign: 'center' }}>
                    {t(
                        'sign-up.verify-email-description',
                        'A one-time verification code has been sent to {{email}}. You will receive an email in the next 5 minutes. Enter the code below:',
                        { email }
                    )}
                </Text>
            </Stack>
            <Form onSubmit={handleConfirmationCode}>
                <Stack sx={{ mt: 6 }} spacing={6}>
                    <TextInput
                        autoComplete={'one-time-code'}
                        inputMode={'numeric'}
                        error={Boolean(error)}
                        helperText={error}
                        label={'Verification Code'}
                        placeholder={'Enter verification code'}
                        value={code}
                        onChange={(event) => handleChange('code', event.target.value)}
                        required
                    />
                    <Button loading={loading} type={'submit'}>
                        Enter
                    </Button>
                </Stack>
            </Form>
            <Stack alignItems={'center'} sx={{ marginTop: 3 }}>
                <SignUpText variant={'p3'}>
                    <Trans
                        i18nKey='auth:sign-up.resend-code'
                        components={{
                            'resend-email': (
                                <Button
                                    size={'small'}
                                    variant={'borderless'}
                                    onClick={handleResendCode}
                                    sx={{ textDecoration: 'underline' }}
                                />
                            ),
                        }}
                    >
                        Didn’t receive the email? <resend-email>Resend Email</resend-email>
                    </Trans>
                </SignUpText>
            </Stack>
        </VerifyEmailBox>
    );
};

const VerifyEmailBox = styled(Box)(({ theme, device }) => {
    return {
        marginTop: theme.spacing(12),
        padding: theme.spacing(7),
        height: 'fit-content',
        ...(device === 'mobile' && {
            position: 'relative',
            width: '100%',
            padding: 0,
        }),
        ...(device === 'tablet' && {
            width: 365,
            background: theme.palette.ensightful.shades[0],
            boxShadow: theme.palette.ensightful.shadows[1],
            borderRadius: '20px',
        }),
        ...(device === 'desktop' && {
            width: 450,
            background: theme.palette.ensightful.shades[0],
            boxShadow: theme.palette.ensightful.shadows[1],
            borderRadius: '12px',
        }),
    };
});

const SignUpText = styled(Text)(({ theme }) => {
    return {
        color: theme.palette.ensightful.neutral[700],
    };
});

export default FinishedSignupPage;
